import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';

import { isString } from '@common/utils/type';

/**
 * Same functionality as Redirect component provided by `react-router-dom`
 * with just one difference which is this component forwards query params to
 * the redirected route
 */
function SafeRedirect({ to, ...remainingProps }) {
  const baseTo = isString(to) ? { pathname: to } : to;

  return (
    <Route
      render={({ location }) => (
        <Redirect
          {...remainingProps}
          to={{
            ...baseTo,
            search: location.search,
          }}
        />
      )}
    />
  );
}

SafeRedirect.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
};

export default SafeRedirect;
